export enum CompanyTypeEnum {
    NORMAL = 1,
    PREFERRED,
    PREFERRED_PLUS,
    DESIGNATE
}
